export enum AmplitudeAnalyticsEvent {
  // DASHBOARD (B2XPORTAL & B2XMOBILE)

  // Dashboard
  acctstatement_export_schd,
  acctstatement_export,
  acctstatement_filter,
  acctstatement_withdraw_schd,
  acctstatement_withdraw,
  analytics_load,
  authenticator_otp_activate,
  authenticator_otp_deactivate,
  auto_withdrawal_config,
  choose_entity_type,
  choose_file_export,
  choose_provide_pjp,
  click_activate,
  click_add_new_category,
  click_arrow_available_balance,
  click_business_link_guide,
  click_business_link_platform,
  click_button_learn_more_overbooking,
  click_change_language,
  click_chart,
  click_close,
  click_confirm_disconnect_child,
  click_confirm_top_up_child,
  click_copy_bca_account_number,
  click_copy_manual_topup,
  click_copy_unique_amount,
  click_copy_va_topup,
  click_custom_column,
  click_delete_category,
  click_disconnect_child,
  click_edit_category,
  click_export,
  click_filter,
  click_guidelines_button,
  click_here_referral,
  click_hide_or_show_balance,
  click_how_to_top_up,
  click_information_detail,
  click_login,
  click_logout,
  click_next,
  click_overbooking_tab,
  click_register_account,
  click_request_otp,
  click_save_changes,
  click_request_changes,
  click_save_custom_column,
  click_search_faq,
  click_shortcut_onboarding,
  click_sign_up,
  click_submit_amount_bca_topup,
  click_submit_now_manual_topup,
  click_top_up_child,
  click_top_up_unique_code,
  click_try_demo,
  click_user_profile_link,
  click_user_profile_tab,
  click_video_tutorial,
  click_withdraw,
  environment_button,
  hit_login_page,
  hit_register_page,
  hit_relogin_page,
  hover_bar,
  input_brandname,
  input_country_code,
  input_email,
  input_fullname,
  input_password,
  input_phonenumber,
  input_referral_code,
  input_top_up_child_amount,
  input_username,
  mam_submit_filter,
  menubar_button,
  select_business_link_platform,
  select_business_link,
  select_business_type,
  select_category,
  select_drop_down_records,
  select_granularity,
  select_sidebar,
  select_time_range,
  tick_remember_this_device,
  upload_business_profile_photo,
  upload_business_store_photo,
  usermgmt_create_user,
  view_account_statement_page,
  view_home_page,
  view_manual_top_up_confirmation_page,
  view_manual_top_up_info_page,
  view_page,
  view_settlement_report_page,
  view_va_top_up_info_page,
  view_withdraw_page,
  click_expand_table,
  click_collapse_table,

  // Settings
  click_settings_menu,

  // Activity Log
  click_filter_activity_log,

  // User Feedback
  submit_feedback_loop_form,
  click_exit_feedback_loop_form,

  // User Suggestion
  submit_suggest_form,
  click_exit_suggest_form,

  // FAQ
  click_faq_content_category,
  click_faq_content,
  click_help_button,

  // Manual TopUp
  click_see_detail_manual_top_up,
  click_understand_button_manual_top_up_detail,

  //eCatalogue
  click_ecatalogue_producttab,

  // Payment Checkout
  apply_export_payment_checkout,
  apply_filter_payment_checkout,
  clear_filter_payment_checkout_list_page,
  clear_filter_payment_checkout,
  click_action_payment_checkout,
  click_cancel_payment_checkout,
  click_close_success_pop_up_payment_checkout,
  click_copy_link_success_pop_up_payment_checkout,
  click_create_link_payment_checkout,
  click_customer_detail_accordion_payment_checkout,
  click_dropdown_records_payment_checkout,
  click_file_dropdown_payment_checkout,
  click_payment_checkout_config_accordion_payment_checkout,
  click_reset_custom_column_payment_checkout,
  initial_view_dashboard_payment_checkout,
  initial_view_payment_checkout_creation,
  input_amount_payment_checkout,
  input_customer_notes_payment_checkout,
  input_description_payment_checkout,
  input_email_payment_checkout,
  input_filter_creation_date_payment_checkout,
  input_filter_customer_name_payment_checkout,
  input_filter_customer_phone_number_payment_checkout,
  input_filter_partner_tx_id_payment_checkout,
  input_filter_search_payment_checkout,
  input_filter_combine_tx_name_phone_payment_routing,
  input_filter_transaction_id_incoming_payment,
  input_name_payment_checkout,
  input_partner_tx_id_payment_checkout,
  input_phone_number_payment_checkout,
  modify_admin_fee_method_payment_checkout,
  modify_amount_type_payment_checkout,
  modify_payment_link_expiration_date_payment_checkout,
  modify_payment_method_payment_checkout,
  modify_payment_type_payment_checkout,
  modify_transaction_due_date_payment_checkout,
  payment_export,
  payment_filter,
  save_custom_column_payment_checkout,
  save_payment_checkout,
  select_filter_payment_method_used_payment_checkout,
  select_filter_status_payment_checkout,
  untick_amount_info_custom_column_payment_checkout,
  untick_customer_info_custom_column_payment_checkout,
  untick_transaction_info_custom_column_payment_checkout,
  untick_use_configuration_for_future_transaction_payment_checkout,
  view_filter_popup_payment_checkout,
  view_success_create_pop_up_payment_checkout,

  // KYB
  choose_kyb_terms_and_conditions,
  click_download_document,
  click_get_account_bank_name,
  click_submit,
  failed_get_account_bank_name,
  input_business_link,
  kyb_click_copy_link_email_mobile,
  kyb_click_copy_link_mobile,
  kyb_click_copy_link_wa_mobile,
  kyb_click_mobile_photo,
  kyb_click_next_take_photo,
  kyb_click_retry_photo_ktp_webcam,
  kyb_click_retry_photo_selfie_webcam,
  kyb_click_start_webcam_photo,
  kyb_click_submit_live_photo,
  kyb_click_take_photo_ktp_webcam,
  kyb_click_take_photo_selfie_webcam,
  kyb_click_webcam_photo,
  submit_kyb,
  success_get_account_bank_name,
  tick_product,
  click_verify_business,
  click_close_pkspopup,
  click_view_pks,
  click_submit_pks,
  confirm_pengkinian_data,
  confirm_data_isuptodate,

  // TnC
  tnc_transaction_data,

  // Upgrade Account
  back,
  choose_business_type,
  click_change_business_type,
  click_check_pricing_kyb,
  click_modal_trial,
  click_upgrade_full_service,
  download_all,
  download_document,
  get_bank_account_name,
  negotiation_check_box,
  next,
  notification_config,
  product_chosen,
  referral,
  save_progress,
  upgrade_account,
  upload_foto_ktp_ocr,
  approve_vida_user_consent,

  // Settlement Report
  click_retry_in_progress,

  // Dashboard Notification
  click_dashboard_notification_card,
  click_dashboard_notification,
  click_dashboard_whatsnew_notification_card,
  click_detail_cta_dashboard_notification,
  click_detail_cta_dashboard_whatsnew,
  hit_dashboard_notification_page,
  hit_whatsnew_notification_page,
  click_something_new,
  click_try_card,
  click_blog_card,

  // Bulk Disburse
  bulk_approve,
  bulk_cancel,
  bulk_change_data,
  bulk_create_begin,
  bulk_create_confirmation,
  bulk_create_detail,
  bulk_create_end,
  bulk_create_validation_result,
  bulk_create,
  bulk_export_campaign_details,
  bulk_export,
  bulk_filter_campaign_details,
  bulk_filter,
  bulk_receipt_email,
  bulk_receipt_jpeg,
  bulk_receipt_pdf,
  bulk_receipt_settings,
  bulk_receipt_zip_open_modal,
  bulk_receipt_zip_url,
  bulk_receipt_zip_download,
  bulk_receipt_zip_update,
  bulk_submit,
  bulk_validate_begin,
  bulk_validate_end,
  bulk_validate_name,
  bulk_send_approval,
  bulk_custom_column_save,
  bulk_advance_search_campaign_name,
  bulk_advance_search_description,
  bulk_filter_date_default,
  bulk_filter_date_one_time,
  bulk_custom_date,

  // Bulk Disburse Transactions
  bulk_tab_click,
  bulk_transaction_export,
  bulk_transaction_filter,
  bulk_transaction_custom_column_save,
  bulk_transaction_retry,
  bulk_transaction_advance_search_campaign_name,
  bulk_transaction_advance_search_transaction_note,
  bulk_transaction_advance_search_email,
  bulk_transaction_advance_search_bank_account_number,
  bulk_transaction_advance_search_recipient_name,
  bulk_transaction_advance_search_transaction_id,
  bulk_transaction_filter_date_default,
  bulk_transaction_filter_date_one_time,
  bulk_transaction_custom_date,

  // Inter Remit
  inter_remit_create,
  inter_remit_cancel_creation,
  inter_remit_submit_creation,
  inter_remit_next_step,
  inter_remit_back_step,
  inter_remit_filter,
  inter_remit_export,
  inter_remit_custom_column,
  inter_remit_advance_search_transaction_id,
  inter_remit_advance_search_recipient_name,
  inter_remit_advance_search_sender_name,
  inter_remit_filter_date_default,
  inter_remit_filter_date_one_time,
  inter_remit_custom_date,

  // API Disburse
  disburse_export,
  disburse_filter,
  disburse_custom_column_save,
  disburse_receipt,
  disburse_receipt_open_modal,
  disburse_receipt_url,
  disburse_advance_search_transaction_id,
  disburse_advance_search_partner_tx_id,
  disburse_advance_search_recipient_name,
  disburse_advance_search_bank_account_number,
  disburse_advance_search_transaction_note,
  disburse_filter_date_default,
  disburse_filter_date_one_time,
  disburse_custom_date,

  // Dashboard Notification
  click_all_dashboard_notification,
  click_all_dashboard_whatsnew,
  dashboard_notification_sent,

  // Virtual Account
  create_va_export,
  create_va_filter,
  ewallet_export,
  ewallet_filter,
  incoming_va_export,
  incoming_va_filter,

  // Highlight Tooltips
  first_point_tooltip,
  main_tooltip,
  second_point_tooltip,

  // Transactions Data
  tx_data_link_account,

  // Tooltip production
  upgrade_account_tooltip,

  // Request Form Activation
  request_choose_payment_method,
  request_next_payment_method,
  request_payment_checkout_method,

  // Yellow Messenger
  click_chat_widget,

  // Claim fund
  claim_fund_account_inquiry,
  claim_fund_account_submit,
  claim_fund_action,
  claim_fund_approve,
  claim_fund_create_submit,
  claim_fund_detail_approve,
  claim_fund_detail_reject,
  claim_fund_export_submit,
  claim_fund_filter_apply,
  claim_fund_filter_view,
  claim_fund_reject,
  claim_fund_view_detail,
  create_claim_fund,
  claim_fund_advance_search_partner_tx_id,
  claim_fund_advance_search_recipient_name,
  claim_fund_filter_date_default,
  claim_fund_filter_date_one_time,
  claim_fund_custom_date,

  // Multi Account
  mam_click_accept_request,
  mam_click_check_all_request,
  mam_click_filter_child_bulk_disbursement,
  mam_click_reject_all_request,
  mam_click_reject_request,
  mam_export_children_list,
  mam_export_children_statement,
  mam_finish_add_children,
  mam_start_add_children,

  // Home Analytic
  tap_analytics_month,
  tap_home_menu,

  // NPS Survey
  nps_popup_close,
  nps_value_submit,

  // retry_bulk_disburse
  tap_retry_bulk_campaign,
  tap_retry_bulk_transaction,

  // VA Dashboard
  click_create_VA,
  click_submit_VA,
  click_validate_VA,

  // Invoice
  apply_filter_invoice,
  cancel_save_changes_settings_invoice,
  choose_file_invoice,
  clear_filter_invoice,
  click_action_invoice,
  click_add_new_item_invoice,
  click_browse_to_upload_invoice,
  click_create_invoice,
  click_custom_column_invoice,
  click_delete_item_invoice,
  click_dropdown_records_invoice,
  click_export_invoice,
  click_file_dropdown_invoice,
  click_filter_invoice,
  click_question_mark_logo_invoice,
  click_reset_custom_column_invoice,
  click_save_changes_settings_invoice,
  click_settings_invoice,
  click_understand_logo_invoice,
  close_invoice_link_pop_up,
  confirm_save_changes_settings_invoice,
  copy_invoice_link_popup,
  initial_view_dashboard_invoice,
  initial_view_invoice_creation,
  initial_view_settings_invoice,
  input_amount_invoice,
  input_customer_email_invoice,
  input_customer_full_name_invoice,
  input_customer_notes_invoice,
  input_customer_phone_number_invoice,
  input_date_of_purchase_invoice,
  input_description_invoice,
  input_filter_creation_date_invoice,
  input_filter_customer_name_invoice,
  input_filter_customer_phone_number_invoice,
  input_filter_partner_tx_id_invoice,
  input_hex_manual_primary_color_invoice,
  input_hex_manual_secondary_color_invoice,
  input_item_description_invoice,
  input_item_name_invoice,
  input_logo_url_invoice,
  input_partner_tx_id_invoice,
  input_partner_user_id_invoice,
  input_price_per_item,
  input_quantity_invoice,
  modify_admin_fee_method_invoice,
  modify_amount_type_invoice,
  modify_invoice_detail,
  modify_payment_link_expiration_date_invoice,
  modify_payment_method_invoice,
  modify_transaction_due_date_invoice,
  modify_va_static_invoice,
  pick_primary_color_invoice,
  pick_secondary_color_invoice,
  save_custom_column_invoice,
  save_invoice_link,
  select_dropdown_records_invoice,
  select_filter_payment_method_used_invoice,
  select_filter_status_invoice,
  success_create_invoice_link,
  success_save_changes_settings_invoice,
  untick_amount_info_custom_column_invoice,
  untick_customer_info_custom_column_invoice,
  untick_transaction_info_custom_column_invoice,
  view_filter_popup_invoice,

  // Settlement Report
  apply_export_invoice,
  choose_file_settlement_report,
  click_dropdown_records_settlement_report,
  click_export_settlement_report,
  click_file_dropdown_settlement_report,
  click_filter_settlement_report,
  click_settlement_report_sidebar,
  input_settlement_date_settlement_report,
  input_transaction_date_filter_settlement_report,
  modify_payment_method_filter_settlement_report,
  modify_product_filter_settlement_report,
  modify_settlement_status_filter_settlement_report,
  select_dropdown_records_settlement_report,
  view_filter_settlement_report,

  // Report
  apply_export_settlement_report,
  apply_export_payment_routing,

  // Notification Sidebar
  click_notification_sidebar,
  click_question_mark_logo_notification,
  click_save_changes_notification,
  input_logo_url_notification,
  modify_payment_checkout_invoice_notification,
  modify_virtual_account_notification,
  success_save_changes_notification,
  open_export_via_email_tab_notification,
  save_export_via_email_notification,

  // Multi Approval
  submit_child_multiapproval_config,
  submit_multiapproval_config,

  // Reusable Payment Link
  apply_export_reusable_detail,
  apply_filter_reusable_detail,
  clear_filter_reusable_detail,
  click_action_reusable_detail,
  click_copy_reusable_detail,
  click_created_reusable_link_tab,
  click_go_to_payment_link_reusable_detail,
  click_list_of_all_transactions_tab,
  click_partner_tx_id_detail_reusable,
  click_reset_custom_column_reusable_detail,
  initial_view_partner_tx_id_detail_reusable,
  input_filter_creation_date_reusable_detail,
  input_filter_customer_name_reusable_detail,
  input_filter_customer_phone_number_reusable_detail,
  input_filter_partner_tx_id_reusable_detail,
  save_custom_column_reusable_detail,
  select_filter_payment_method_used_reusable_detail,
  select_filter_status_reusable_detail,
  untick_amount_info_custom_column_reusable_detail,
  untick_customer_info_custom_column_reusable_detail,
  untick_transaction_info_custom_column_reusable_detail,
  view_filter_popup_reusable_detail,

  // Coachmark First Login
  coachmark_firstlogin_environment,
  coachmark_firstlogin_gettingstarted,
  coachmark_firstlogin_start,
  coachmark_firstlogin_upgradeaccount,

  // Payment Checkout MAM
  click_dropdown_child_balance_creation_payment_checkout,
  click_dropdown_filter_child_balance_payment_checkout,
  modify_balance_destination_creation_payment_checkout,
  modify_filter_balance_destination_list_payment_checkout,
  select_child_creation_payment_checkout,
  select_child_filter_payment_checkout,
  tick_balance_destination_custom_column_payment_checkout,
  tick_child_username_custom_column_payment_checkout,
  untick_balance_destination_custom_column_payment_checkout,
  untick_child_username_custom_column_payment_checkout,

  // Child Settlement Report
  click_dropdown_filter_child_balance_child_settlement_report,
  click_filter_child_settlement_report,
  click_retry_in_progress_child_settlement_report,
  initial_view_child_settlement_report,
  input_settlement_date_child_settlement_report,
  input_transaction_date_filter_child_settlement_report,
  modify_payment_method_filter_child_settlement_report,
  modify_product_filter_child_settlement_report,
  modify_settlement_status_filter_child_settlement_report,
  select_child_filter_child_settlement_report,
  select_dropdown_records_child_settlement_report,
  view_filter_child_settlement_report,

  // Form Activation BCA
  click_apply_now_bca,
  click_close_bca_form,
  click_submit_bca_form,
  failed_get_account_name_bca_form,
  input_account_number_bca_form,
  input_business_address_bca_form,
  input_business_link_bca_form,
  input_company_start_date_bca_form,
  input_pic_email_bca_form,
  input_pic_name_bca_form,
  input_pic_phone_number_bca_form,
  input_pic_position_bca_form,
  input_postal_code_bca_form,
  input_total_minimum_transactions_per_day_bca_form,
  input_total_transactions_per_month_bca_form,
  select_city_bca_form,
  select_district_bca_form,
  select_industry_bca_form,
  select_province_bca_form,
  select_subdistrict_bca_form,
  success_get_account_name_bca_form,
  tick_transaction_types_bca_form,

  // Developer Option
  hit_callback_configuration_page,
  click_save_changes_callback_configuration,
  click_transaction_url_validation,
  click_settlement_url_validation,
  click_automatic_retry_callback,

  // Test
  ab_test_demo,

  // PAYCHECKOUT
  // Payment Checkout Link
  api_biller_export,
  click_bayar_sekarang,
  click_connect,
  click_disconnect,
  click_pencil_payment_method,
  click_pencil_personal_info,
  click_refund,
  click_save_phone_number_ovo_form_payment_checkout,
  click_share_payment_link,
  confirm_payment_method,
  detail_va_export,
  detail_va_filter,
  initial_view_payment_checkout_link,
  initial_view_payment_method_modal,
  input_amount,
  input_name,
  input_phone_number_ovo_form_payment_checkout,
  input_phone_number,
  pay_payment_link,
  refresh_status,
  scheduled_disburse_export,
  select_payment_method,
  shrink_personal_info,
  visit_phone_number_ovo_form_payment_checkout,

  //Business Banking
  back_vendor_management_new_vendor_legal,
  back_vendor_management_new_vendor_pic,
  click_account_payable_invoice_back,
  click_account_payable_invoice_details_cancel,
  click_account_payable_invoice_details_download,
  click_account_payable_invoice_details_payment_approve,
  click_account_payable_invoice_details_payment_cancel,
  click_account_payable_invoice_details_payment_details,
  click_account_payable_invoice_details_payment_invoice,
  click_account_payable_invoice_details_payment,
  click_account_payable_invoice_new_line,
  click_account_payable_invoice_new_vendor,
  click_account_payable_invoice_paid,
  click_account_payable_invoice_row,
  click_account_payable_invoice_upload_file,
  click_account_payable_invoice_upload_invoice,
  click_account_payable_new_creation,
  click_account_payable_transaction_late,
  click_account_payable_transaction_new_creation,
  click_account_payable_transaction_see_details,
  click_account_payable_transaction_see_invoice,
  click_customer_management_details,
  click_customer_management_edit,
  click_customer_management_inactive,
  click_customer_management_new_customer,
  click_sidebar_account_payable_invoice,
  click_sidebar_account_payable_transaction,
  click_sidebar_account_payable_vendor_management,
  click_vendor_management_details_edit,
  click_vendor_management_details_inactive,
  click_vendor_management_details,
  click_vendor_management_edit,
  click_vendor_management_inactive,
  click_vendor_management_new_vendor_npwp,
  click_vendor_management_new_vendor_skb,
  click_vendor_management_new_vendor,
  click_popup_international_transfer,
  click_popup_bulk_disbursement,
  click_popup_claim_fund,
  click_popup_disbursement_api,
  click_popup_onetime_payment_link,
  click_popup_reusable_payment_link,
  click_popup_created_va,
  click_popup_incoming_payment,
  click_popup_payment_routing,
  save_account_payable_invoice_creation_data,
  save_account_payable_invoice_creation_payment,
  save_customer_management_new_customer,
  save_vendor_management_new_vendor_legal,
  save_vendor_management_new_vendor_main,
  save_vendor_management_new_vendor_pic,
  view_account_payable_invoice_creation_data,
  view_account_payable_invoice_details,
  view_account_payable_invoice_payment,
  view_account_payable_invoice,
  view_account_payable_late_invoice,
  view_account_payable_transaction_details,
  view_account_payable_transaction,
  view_account_payable_vendor_management,
  view_customer_management_details_edit,
  view_customer_management_details_inactive,
  view_customer_management_details,
  view_vendor_management_details,

  // VCC
  click_vcc_card_promo_cardholder,
  click_vcc_card_promo_dashboard,
  click_vcc_card_promo_banner,
  click_vcc_promo_dashboard,
  click_vcc_promo_card_holder,
  click_vcc_promo_dashboard_others,
  click_vcc_promo_cardholder_others,
  click_create_new_corporate_card,
  click_topup_card_balance,
  click_submit_corporate_card_creation,
  click_corporate_card_view_card_promo,
  click_apply_topup_card_balance,

  view_cardholder_portal,
  view_corporate_card_creation_cardholder_info,
  view_corporate_card_creation_card_usage_details,
  view_corporate_card_creation_confirmation,
  view_corporate_card_txn_list,

  // AR
  save_account_receivable_add_column,
  save_account_receivable_creation_settings,
  save_account_receivable_invoice_new_customer,
  save_account_receivable_payment_method_settings,

  click_account_receivable_action_send_whatsapp,
  click_account_receivable_creation_whatsapp,
  click_account_receivable_details_whatsapp,
  click_sidebar_account_receivable_create_invoice,
  click_sidebar_account_receivable_customer_management,
  click_account_receivable_action_callback_invoice,
  click_account_receivable_action_delete_invoice,
  click_account_receivable_action_download_invoice,
  click_account_receivable_action_send_invoice,
  click_account_receivable_add_column,
  click_account_receivable_add_line,
  click_account_receivable_cancel_invoice_creation,
  click_account_receivable_creation_settings,
  click_account_receivable_delete_line,
  click_account_receivable_details_callback,
  click_account_receivable_details_delete_invoice,
  click_account_receivable_details_download_invoice,
  click_account_receivable_details_send_invoice,
  click_account_receivable_download_invoice,
  click_account_receivable_due_date_settings,
  click_account_receivable_invoice_new_customer,
  click_account_receivable_invoice_row,
  click_account_receivable_new_creation,
  click_account_receivable_payment_method_settings,
  click_account_receivable_save_notes,
  click_account_receivable_send_invoice,
  click_account_receivable_upload_document,
  click_bulk_payment_portal_pay,
  click_bulk_payment_portal_confirmation,

  view_account_receivable_create_invoice,
  view_account_receivable_creation,
  view_account_receivable_customer_management,
  view_account_receivable_invoice_details,
  view_bulk_payment_portal_list,

  // Bank Maintenance
  notification_mark_as_read,
  click_bank_maintenance_button,
  click_bank_maintenance_message,
  click_bank_maintenance_tab_daily,
  click_bank_maintenance_tab_adhoc,

  // Auto Report
  auto_report_activate,
  auto_report_activate_success,
  auto_report_edit_config,
  auto_report_edit_config_success,
  auto_report_deactive,
  auto_report_from_export,
  auto_report_deactive_success,

  // List Bank Code
  bank_code_list,
}
